import { render, staticRenderFns } from "./FeaturesView.vue?vue&type=template&id=3353b7d7"
import script from "./FeaturesView.vue?vue&type=script&lang=js"
export * from "./FeaturesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports